import { render, staticRenderFns } from "./ServiceTable.vue?vue&type=template&id=a63eda60&"
import script from "./ServiceTable.vue?vue&type=script&lang=js&"
export * from "./ServiceTable.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTable.vue?vue&type=style&index=0&id=a63eda60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports